import { useReferral } from "@/hooks/useReferral";

export const ReferralTracker = () => {
  useReferral(); // Captures 'ref' param and saves to session storage
  return null;
};
